import React from 'react'
import { Column } from 'components/common/layout'
import { BoxInput } from 'components/common/input'

export const LinkUploader: React.FC<{
  links: string[]
  setLinks: React.Dispatch<React.SetStateAction<string[]>>
}> = ({ links, setLinks }) => {
  const handleLinkChange = (value: string, index: number) => {
    const newValues = [...links]
    newValues[index] = value
    // 마지막 인덱스에 값이 입력되면 여분의 빈 인풋 추가
    if (value !== '' && index === links.length - 1) newValues.push('')
    // 배열에서 빈 값이 2개 이상이면 마지막 빈 값만 남기고 나머지는 제거
    const filteredValues = newValues.filter(
      (v, i) => i === newValues.length - 1 || v !== '',
    )
    setLinks(filteredValues)
  }

  return (
    <Column style={{ gap: 8 }}>
      <BoxInput
        value={links[0]}
        onChange={(e) => handleLinkChange(e.target.value, 0)}
        placeholder='https://example.com'
      />
      {links.map((item, index) => {
        if (index === 0) return
        return (
          <BoxInput
            key={index}
            value={item}
            onChange={(e) => handleLinkChange(e.target.value, index)}
            placeholder='https://example.com'
          />
        )
      })}
    </Column>
  )
}
